import { render, staticRenderFns } from "./CaregiverBehavior.vue?vue&type=template&id=5c708863&scoped=true"
import script from "./CaregiverBehavior.vue?vue&type=script&lang=js"
export * from "./CaregiverBehavior.vue?vue&type=script&lang=js"
import style0 from "./CaregiverBehavior.vue?vue&type=style&index=0&id=5c708863&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c708863",
  null
  
)

export default component.exports